import axios from 'utils/axios';
import Manage from '../types/manage';

export const createServicePackage = (servicePackages: Manage.ServicePackages.Request) => {
  return axios.post(`/api/v1/servicepackages/mfo`, { ...servicePackages });
};
